@if (loading()) {
  <app-loading></app-loading>
}@else {
  <div class="container">
    @if (invite() && isInviteValid(invite())) {
      <img src="imgs/icon.png" class="logo-icon">
      <div class="title">
        MyMindLog
      </div>
      <div class="sub-title">
        {{'accept-invite.invite' | translate:{email: $safeNavigationMigration(invite()?.email)} }}
      </div>
      <div class="message">
        {{'accept-invite.invite_message' | translate:{psychologist: $safeNavigationMigration(invite()?.psychologist_name)} }}
      </div>
      <div class="info">
        {{'accept-invite.invite_info' | translate:{email: $safeNavigationMigration(invite()?.email)} }} 
      </div>
      <div class="form-container">
        <div class="actions-container">    
          <app-button
            [buttonLabel]="'buttons.ignore' | translate"
            [buttonType]="BUTTON_TYPES.OUTLINED" 
            (click)="continue()">
          </app-button>
          <app-button
            [buttonLabel]="'buttons.accept' | translate"
            [buttonType]="BUTTON_TYPES.GREEN" 
            (click)="accept()">
          </app-button>
        </div>
      </div>
    }@else {
      <img src="imgs/negative.png" class="logo-icon">
      <div class="title">
        MyMindLog
      </div>
      <div class="sub-title">
        {{'accept-invite.invite_invalid' | translate}}
      </div>
      <div class="message">
        {{'accept-invite.invite_invalid_message' | translate}}
      </div>
      <div class="form-container">
        <div class="actions-container">    
          <app-button
            [buttonLabel]="'buttons.OK' | translate"
            [buttonType]="BUTTON_TYPES.REGULAR" 
            (click)="continue()">
          </app-button>
        </div>
      </div>
    }
  </div>
}
